/**
 * MILLENIUM 2027 — Année Européenne des Normands
 * Logo officiel (PNG fourni). Variante vertical par défaut, horizontal disponible.
 */
export default function MilleniumBadge({ size = 120, variant = "vertical", className = "" }) {
  const src = variant === "horizontal"
    ? "/photos/millenium-horizontal.png"
    : "/photos/millenium-vertical.png";
  const style = variant === "horizontal"
    ? { height: size, width: "auto" }
    : { width: size, height: "auto" };
  return (
    <img
      src={src}
      alt="Millenium 2027 — Année Européenne des Normands"
      style={style}
      className={className}
    />
  );
}

